import type { ApiErrorBody } from '@/types/api'

/**
 * A normalised API failure.
 *
 * Every backend error carries a stable machine `code` and a `requestId` that also
 * appears in server logs, so a user-reported failure is traceable (SDD Appendix B).
 */
export class ApiError extends Error {
  readonly status: number
  readonly code: string
  readonly fieldErrors: Record<string, string[]>
  readonly requestId: string | undefined

  constructor(status: number, body: Partial<ApiErrorBody>, fallback: string) {
    super(body.message ?? fallback)
    this.name = 'ApiError'
    this.status = status
    this.code = body.code ?? 'unknown_error'
    this.fieldErrors = body.field_errors ?? {}
    this.requestId = body.request_id
  }

  /** The tenant is suspended or read-only (HTTP 423). */
  get isTenantLocked(): boolean {
    return this.status === 423
  }

  /** Stale version or state/concurrency conflict (HTTP 409). */
  get isConflict(): boolean {
    return this.status === 409
  }
}
